module.exports = __webpack_public_path__ + "img/1053268058.acae1697.jpg";